import React from "react";

interface EvidenceTitleProps {
  title?: string;
}

const EvidenceTitle: React.FC<EvidenceTitleProps> = ({ title }) => {
  if (!title) return null;

  return (
    <div>
      <div className="readEvidenceTitle">{title}</div>
      <div className="h-[1px] w-full bg-grey-30 mt-4" />
    </div>
  );
};

export default EvidenceTitle;
